var map = {
	"./cmn_msg_de.json": 2057,
	"./cmn_msg_en.json": 2058,
	"./cmn_msg_es.json": 2059,
	"./cmn_msg_fr.json": 2060,
	"./cmn_msg_it.json": 2061,
	"./cmn_msg_ja.json": 2062,
	"./cmn_msg_nl.json": 2063,
	"./cmn_msg_pt.json": 2064,
	"./cmn_msg_zh.json": 2065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2056;